import { hexToRGB, parseDate, WCGAcheck } from './utils'

import Vue from 'vue'
import uuid from 'uuid/v4'

// WHEN REMOVING/ADDING MIXINS REMEBER TO ALSO REMOVE/ADD THEM IN "global.d.ts" !!
Vue.mixin({
  methods: {
    parseDate(date, format) {
      return parseDate(date, format)
    },
    openFSPicker() {
      this.$refs['file-input'].$refs['input'].click()
    },
    isArray(value) {
      return Array.isArray(value)
    },
    getUID() {
      return uuid()
    },
    getThemeStyle(color, opacity, defaultColor = 'primary') {
      const colors = {
        primary: { r: 2, g: 119, b: 189 },
        secondary: { r: 255, g: 76, b: 0 },
      }
      const isHex = color && color.startsWith && color.startsWith('#')
      const rgbColor = isHex ? hexToRGB(color) : color
      const chosenColor = rgbColor ? rgbColor : colors[defaultColor]

      const { r, g, b } = WCGAcheck(chosenColor, colors, opacity)

      if (opacity) {
        return `rgba(${r}, ${g}, ${b}, ${opacity})`
      }

      return `rgb(${r}, ${g}, ${b})`
    },
    log(value) {
      console.log(value)
    },
  },
})
